var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 412,
    viewBox: "0 0 375 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_18_3559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-229.73 193.177C-229.73 193.177 -128.114 -97.936 192.5 -10.5545C513.114 76.827 614.73 -214.286 614.73 -214.286",
    stroke: "url(#paint0_radial_18_3559)",
    strokeWidth: 115.808
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_18_3559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-229.73 193.177C-229.73 193.177 -128.114 -97.936 192.5 -10.5545C513.114 76.827 614.73 -214.286 614.73 -214.286",
    stroke: "url(#paint1_radial_18_3559)",
    strokeWidth: 115.808
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_18_3559",
    x: -336.491,
    y: -285.741,
    width: 1057.98,
    height: 550.372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.0568,
    result: "effect1_foregroundBlur_18_3559"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_18_3559",
    x: -290.168,
    y: -239.418,
    width: 965.337,
    height: 457.726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8952,
    result: "effect1_foregroundBlur_18_3559"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18_3559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.433 -84.4611) rotate(109.242) scale(424.146 406.775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0479167,
    stopColor: "#2D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846416,
    stopColor: "#47DEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_18_3559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.251 -244.368) rotate(109.242) scale(593.515 569.208)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0479167,
    stopColor: "#714DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504878,
    stopColor: "#9380FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur);
export default __webpack_public_path__ + "static/media/Blur.6a259612ac9cd509715c79e77d54e167.svg";
export { ForwardRef as ReactComponent };